// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__74SKL"};
module.exports.__checksum = "c60f19530d5a"